import axios from 'axios';
import { baseURL } from '../helpers/constants.js';

export async function getAllPosts(params) {
  const endPoint = '/posts';
  const url = baseURL + endPoint;

  const res = await axios.get(url, { params });
  return res.data;
}

export async function getPostDetails(id, params) {
  const endPoint = `/posts/${id}/localized`;
  const url = baseURL + endPoint;

  const res = await axios.get(url, { params });
  return res.data.data;
}
export async function createPost(object) {
  const endPoint = `/posts`;
  const url = baseURL + endPoint;

  const res = await axios.post(url, object);
  return res.data;
}

export async function deletePost(id) {
  const endPoint = `/posts/${id}`;
  const url = baseURL + endPoint;

  const res = await axios.delete(url);
  return res.data;
}
